import { supabase } from '../lib/supabase';

const addOrUpdateRating = async ({ userId, lessonId, rating }) => {
  const payload = { lesson_id: lessonId, user_id: userId, rating };
  const { data, error } = await supabase
    .from('lesson_ratings')
    .upsert(payload, { onConflict: ['lesson_id', 'user_id'] })
    .select('*')
    .single();

  if (error) throw error;
  return data;
};

const getLessonRatings = async (lessonId) => {
  const { data, error } = await supabase
    .from('lesson_ratings')
    .select('user_id, rating, created_at')
    .eq('lesson_id', lessonId);

  if (error) throw error;
  return data || [];
};

const getAverageRatingsForLessons = async (lessonIds = []) => {
  if (!lessonIds || lessonIds.length === 0) return {};

  const { data, error } = await supabase
    .from('lesson_ratings')
    .select('lesson_id, rating')
    .in('lesson_id', lessonIds);

  if (error) throw error;

  const map = {};
  (data || []).forEach(row => {
    const id = row.lesson_id;
    if (!map[id]) map[id] = { sum: 0, count: 0 };
    map[id].sum += Number(row.rating || 0);
    map[id].count += 1;
  });

  const result = {};
  Object.keys(map).forEach(id => {
    result[id] = map[id].count > 0 ? map[id].sum / map[id].count : null;
  });

  return result;
};

export const lessonRatingsService = {
  addOrUpdateRating,
  getLessonRatings,
  getAverageRatingsForLessons
};
